import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from "~/components/common/dialog";
import { Field } from "~/components/common/fieldset";
import { Button } from "~/components/common/button";
import { Textarea } from "~/components/common/textarea";
import { useState } from "react";
import { toast } from "react-toastify";

export function FeedbackDialog({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) {
  const [feedback, setFeedback] = useState("");

  return (
    <Dialog open={isOpen} onClose={setIsOpen}>
      <DialogTitle>Share feedback</DialogTitle>
      <DialogDescription>
        We’re always looking for ways to improve. Share your thoughts with us.
      </DialogDescription>
      <DialogBody>
        <Field>
          <Textarea
            name="feedback"
            onChange={(e) => setFeedback(e.target.value)}
          />
        </Field>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={() => setIsOpen(false)}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            setIsOpen(false);
            toast.success("Thanks for your feedback!");
            const formData = new FormData();
            formData.append("feedback", feedback);
            fetch("/api/send-feedback", {
              method: "POST",
              body: formData,
            });
          }}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
